var map = {
	"./jedenascie-medytacji-thumb.png": 696,
	"./lakier-thumb.png": 40,
	"./tylko-ateisci-zostana-zbawieni-thumb.png": 369,
	"./w-raju-thumb.png": 116,
	"./zly-syn-thumb.png": 530,
	"./zrolowany-wrzesniowy-vogue-thumb.png": 138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 865;